const c = (e, n = 40) => {
  const o = e.length;
  if (o < n) return e;
  const t = (n - 3) / 2;
  return `${e.substring(0, t)}...${e.substring(o - t)}`;
}, l = (e) => {
  e.style.width = "100%";
  const n = e.clientWidth;
  e.style.width = "auto";
  const o = e.getAttribute("data-og-str");
  if (!o) return "";
  const t = e.cloneNode(!0);
  if (t.style.minWidth = `${e.clientWidth}px`, t.style.maxWidth = `${e.clientWidth}px`, t.style.overflow = "hidden", t.style.textOverflow = "ellipsis", t.style.whiteSpace = "nowrap", t.style.position = "absolute", t.style.right = "-9999px", t.textContent = o + "...", ["fontFamily", "fontSize", "fontWeight", "fontStretch"].forEach((s) => {
    t.style[s] = getComputedStyle(e)[s];
  }), document.body.appendChild(t), t.scrollWidth <= n)
    return t.remove(), o;
  const a = n / t.scrollWidth;
  t.remove();
  const i = Math.floor(o.length * a) - 1.5;
  return c(o, i);
}, d = {
  mounted: (e) => {
    const n = e.querySelectorAll(
      "[data-truncate-target]"
    );
    if (!n.length) {
      console.error(
        `At least one element with data-truncate-target doesn't exist in ${e.outerHTML}`
      );
      return;
    }
    n.forEach((t) => {
      t.setAttribute("data-og-str", t.textContent || "");
    });
    const o = () => {
      Array.from(n).forEach((t) => {
        const r = l(t);
        t.textContent = r;
      });
    };
    new ResizeObserver(o).observe(e);
  }
};
export {
  d as default
};
